import styled from "styled-components";
import photo1 from "assets/images/2-Benjamin-Abrahão-Lampião-e-M-Bonita-1936-IMS.jpg";
import photo2 from "assets/images/3-Livro-Estrelas-de-Couro-2.jpg";
import photo3 from "assets/images/4.jpg";
import photo3Mobile from "assets/images/4-mobile.jpg";
import photo4 from "assets/images/5.jpg";
import photo5 from "assets/images/6.jpg";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    flex-shrink: unset;
    flex-grow: unset;
    height: auto;
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: 100%;
  padding: 48px 130px;

  @media screen and (max-width: 1010px) {
    padding: 72px 41px;
    width: 100%;
    height: auto;
  }
`;

export const WrapperAllTexts = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansWideMedium};
  font-size: 32px;
  line-height: 40px;
  margin-bottom: 32px;
  color: black;

  @media screen and (max-width: 414px) {
    font-size: 26px;
    line-height: 32px;

    &.empty {
      display: none;
    }
  }
`;

export const WrapperColumns = styled.div`
  display: flex;
  column-gap: 100px;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const Column = styled.article`
  width: 333px;
  height: 380px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: black;

  p {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }

  @media screen and (max-width: 414px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const WrapperPhoto = styled.div`
  padding: 48px 0;
  height: 100vh;
  position: relative;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
    padding: 0;
  }
`;

export const PhotoLegend = styled.span`
  font-family: ${fonts.BentonSansRegular};
  font-size: 12px;
  line-height: 16px;
  display: inline-block;
`;

export const Photo1Legend = styled(PhotoLegend)`
  color: black;
  margin-top: 8px;

  @media screen and (max-width: 1010px) {
    margin-top: 16px;
    padding: 0 41px;
    max-width: 330px;
  }
`;

export const Photo2Legend = styled(PhotoLegend)`
  color: black;
  margin-top: 8px;

  @media screen and (max-width: 1010px) {
    margin-top: 16px;
    padding: 0 41px;
    max-width: 330px;
  }
`;

export const WrapperPhotoLegend = styled.div`
  width: 100%;
  position: relative;
`;

export const Photo3Legend = styled(PhotoLegend)`
  color: white;
  font-size: 15px;
  line-height: 22px;
  position: absolute;
  bottom: 32px;
  left: 40px;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const Photo3LegendMobile = styled.span`
  font-family: ${fonts.BentonSansRegular};
  font-size: 12px;
  line-height: 16px;
  color: black;
  margin-top: 16px;
  display: none;
  padding: 0 41px;

  @media screen and (max-width: 1010px) {
    display: block;
  }
`;

export const Photo4Legend = styled(PhotoLegend)`
  color: black;
  margin-top: 8px;

  @media screen and (max-width: 1010px) {
    margin-top: 16px;
    padding: 0 41px;
    max-width: 330px;
  }
`;

export const Photo5Legend = styled(PhotoLegend)`
  color: white;
  font-size: 15px;
  line-height: 22px;
  position: absolute;
  bottom: 32px;
  left: 40px;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const Photo5LegendMobile = styled.span`
  font-family: ${fonts.BentonSansRegular};
  font-size: 12px;
  line-height: 16px;
  color: black;
  margin-top: 16px;
  display: none;
  padding: 0 41px;

  @media screen and (max-width: 1010px) {
    display: block;
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  width: auto;
  height: 98%;
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  width: auto;
  height: 98%;
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo3 = styled.div`
  width: 100%;
  min-width: 100vw;
  height: 100vh;
  display: flex;
  background: url(${photo3}) no-repeat left center;
  background-size: cover;
  background-attachment: fixed;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const Photo3Mobile = styled.img.attrs({ src: photo3Mobile })`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: none;

  @media screen and (max-width: 1010px) {
    display: block;
  }
`;

export const Photo4 = styled.img.attrs({ src: photo4 })`
  width: auto;
  height: 98%;
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo5 = styled.div`
  width: 100%;
  min-width: 100vw;
  height: 100vh;
  display: flex;
  background: url(${photo5}) no-repeat left center;
  background-size: cover;
  background-attachment: fixed;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const Photo5Mobile = styled.img.attrs({ src: photo5 })`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: none;

  @media screen and (max-width: 1010px) {
    display: block;
  }
`;
